import { IUser } from '../types/user';
import { create, StateCreator } from "zustand";
import { createJSONStorage, persist, PersistOptions } from 'zustand/middleware';
import { ITables } from '../types/store';
import { logger } from '../utils/logger';

export interface IUseLng {
  i18nId: number,
  languageCode: string,
  languageName: string
}

type UserStore = {
  isAyce: boolean;
  isLogin: boolean;
  loginMode: string;
  userInfo: IUser|null;
  tableInfo: ITables;
  orderBook: boolean;
  currentLng: string;
  selectLng: IUseLng;
  useLng: IUseLng[];
  version: string;
  setIsAyce: (value:boolean) => void;
  setLoginMode: (value:string) => void;
  setIsLogin: (value: boolean) => void;
  setUserInfo: (value:IUser|null) =>  void;
  setTableInfo: (value:ITables) =>  void;
  setOrderBook: (value: boolean) => void;
  setlng: (value: string) => void;
  setlngItem: (value: IUseLng) => void;
  setUseLanguage: (value: IUseLng[]) => void;
  setVersion: (val: string|undefined) => void;
  logout: () => void;
}

type MyPersist = (
  config: StateCreator<UserStore>,
  options: PersistOptions<UserStore>
) => StateCreator<UserStore>

type State = {
  isAyce: boolean;
  isLogin: boolean;
  loginMode: string;
  userInfo: IUser|null;
  tableInfo: ITables;
  orderBook: boolean;
  currentLng: string;
  selectLng: IUseLng;
  useLng: IUseLng[];
  version: string;
}

const initialState: State = {
  isAyce: false,
  isLogin: false,
  loginMode: 'normal',
  userInfo: null,
  tableInfo: {} as ITables,
  orderBook: false,
  selectLng: { i18nId: 0, languageCode: '', languageName: '' } as IUseLng,
  useLng: [],
  version: 'v1.0.0',
  currentLng: 'en',
}

export const useInfoStore = create<UserStore>(
    (persist as MyPersist)(
      (set, get): UserStore =>  ({
      ...initialState,
      setIsAyce: (value:boolean) => set({isAyce: value}),
      setLoginMode: (value: string) => {
        set({ loginMode: value });
      },
      setIsLogin: (value: boolean) => {
        set({ isLogin: value });
      },
      setUserInfo: (info: IUser|null) => {
        set({ userInfo: info });
      },
      setTableInfo: (info: ITables) => {
        set({ tableInfo: info });
      },
      setOrderBook: (value: boolean) => {
        set({ orderBook: value });
      },
      setlng: (lng: string) => {
        set({ currentLng: lng });
      },
      setlngItem: (lng: IUseLng) => {
        set({ selectLng: lng });
      },
      setUseLanguage: (languages: IUseLng[]) => {
        set({ useLng: languages });
      },
      setVersion: (value: string | undefined) => {
        set({ version: value });
      },
      logout: () => {
        // persist 설정을 유지하면서 상태만 리셋
        // localStorage는 persist가 자동으로 처리
        set(initialState);
        
        logger.debug('User logged out, userInfoStore state reset to initialState.');
      },
    }),
    {
      name: 'userInfo',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
